// extracted by mini-css-extract-plugin
export default {"circle":"InactiveTileTrigger_circle__+k5me","icon":"InactiveTileTrigger_icon__L4Ig8"};